module.exports = __webpack_public_path__ + "img/icon_sec6_04.c2f5c39c.png";